module.exports = __webpack_public_path__ + "img/14.5a70633c.png";